module.exports = __webpack_public_path__ + "static/media/294036.96690883.png";